import React from 'react'
import intl from 'react-intl-universal'
import { Link } from '@raysync/common/components'
import { TabWrap, TabHeader, TabTitle } from './atoms'
export const Tab = ({ location }) => {
  const path = location.pathname.replace(/\/$/, '')
  return (
    <TabWrap>
      <TabHeader>
        <TabTitle active={path.startsWith('/support/document/product')}>
          <Link to='/support/document/product/release'>{intl.get('support.product-document')}</Link>
        </TabTitle>
        <TabTitle active={path === '/support/document'}>
          <Link to='/support/document'>{intl.get('support.white-paper')}</Link>
        </TabTitle>
        <TabTitle active={path === '/support/video'}>
          <Link to='/support/video'>{intl.get('support.tab.title3')}</Link>
        </TabTitle>
      </TabHeader>
    </TabWrap>
  )
}
